import { isArray } from "lodash";

export default {
    data() {
        return {
            isRouteChange: true,

            indexedDB: null,
            request: null,
            db: null,
        };
    },
    methods: {
        reloadTable(tableID) {
            $(tableID).DataTable().ajax.reload();
            // in case any checkbox is still checked when delete a row, reset the checkbox
            // required for consolidationPopup.vue
            $(tableID).DataTable().column(0).checkboxes.deselectAll();
            console.log(tableID + " reload from mixin");
        },
        tableLinkID(tableID) {
            var self = this;
            $(tableID + " tbody").on( "click", ".tableLinkID", function() {
                event.preventDefault();
                var id = $( this ).data().passingid ;
                var page = $( this ).data().detailpage ;

                // PUSH TO THE PAGE
			  	self.$router.push({ name: page, params: { id } });

                // let route = self.$router.resolve(detailPage + id);
                // window.open(route.href, '_blank');
            });
        },
        tableActionDelete(name, link) {
            $( name + " tbody").on( "click", ".tableActionDelete", function() {
			  var id = $(this).data().passingid ;

			  EventBus.$emit("deleteDialog", {
			    text: "Are you sure to delete the item ?",
			    id: id,
			    name: name,
			    link: link,
			  });			  
            });
        },
        confirmDeleteTableItem(id, name, link) {
            var self = this;
            axios({
		  		method: "DELETE",
		  		url: link + "/Delete",
		  		params: {
		  			Id: id
		  		}
		 	})
		  	.then(function (response) {
		  		EventBus.$emit("snackBar", {
		  		  text: "Row Deleted",
		  		  snackbarColor: "green darken-2"
		  		});
		  		self.reloadTable(name);
		  	});
        },
        tableActionLoopingFormEdit(name, link, title) {
            var self = this;
            $(name + " tbody").on( "click", ".tableActionEdit", function() {
                var id = $(this).data().passingid ;

			  	self.getID = id;
			  	self.isEditLoopingForm = true;
			  	self.formDetails.formAction = "Update";
			  	self.formDetails.submitHttp = "PUT";
            });
        },
        tableActionEdit(name, link, title) {
            $(name + " tbody").on( "click", ".tableActionEdit", function() {
			  var id = $(this).data().passingid ;

                var payload       = {};
                payload.id        = id;
                payload.fn        = "EDIT";
                payload.link      = link;
                payload.tableName = name;
                payload.title     = title;
                payload.isDialog  = true;

			  store.commit("editTableDialog", payload);
            });
        },
        $_checkRecordFlag(flaggedData) {
            var tooltipTitle = "";
            flaggedData.forEach((data, index) => {
                tooltipTitle = tooltipTitle + ">> " + data.fieldDataFlag.condition + "\n";
            });
            return tooltipTitle;
        },
        addConfBtn(name, link, title) {
            var payload       = {};
            payload.id        = "";
            payload.fn        = "ADD";
            payload.link      = link;
            payload.tableName = name;
            payload.title     = title;
            payload.isDialog  = true;

            store.commit("addDialog", payload);
        },
        addTo2Decimal(string) {
            if (string == "-" || string == null) return "-";

            return parseFloat(Math.round(string * 100) / 100).toFixed(2);
        },
        $_formatDecimalPoints(string) {
            if (string == "-" || string == null) return "-";
            var value = parseFloat(string);
            var toFixed = 2;
            var multiple = 100;

            if (value > 0 && value < 1 )
            {
                var str = string.toString();
                var d_points = str.indexOf(".");
                var decimals = str.substring(d_points + 1);
                var leadingZeros = 0;

                for (var i = 0; i < decimals.length && decimals[i] == "0"; i++) { 
                    leadingZeros++;
                }

                if (leadingZeros >= 2 && leadingZeros < 5)
                {
                    toFixed = leadingZeros + 1;
                    multiple = Math.pow(10, toFixed);
                }
            }
            
            return parseFloat(Math.round(string * multiple) / multiple).toFixed(toFixed);
        },
        $_addTo2Decimal(string) {
            if (string == "-" || string == null) return "-";
            return parseFloat(Math.round(string * 100) / 100).toFixed(3);
        },
        formatYear(date) {
            if (date) return moment(date).local().format("YYYY");
            else return "-";
        },
        formatDate(date) {
            if (date) return moment(date).local().format("DD MMM YYYY");
            else return "-";
        },
        formatCreationTime(date) {
            if (date) return moment(date).local().format("lll");
            else return "-";
        },
        initTooltip(tableId) {
            $(tableId).on("draw.dt", function () {
                $("[data-toggle=\"tooltip\"]").tooltip();
            });
        },
        toTitleCase(str) {
            if (str) {
			    return str.replace(
			        /\w\S*/g,
			        function(txt) {
			            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
			        }
			    );
            }
        },
        runSearch(tableID) {
            if (window.localStorage.getItem("globalSearchQuery")) {
                $(tableID).DataTable().search( window.localStorage.getItem("globalSearchQuery") ).draw();
                window.localStorage.removeItem("globalSearchQuery");
            }
        },
        realignTable() {
		  setTimeout(function() {
		    $($.fn.dataTable.tables( true )).DataTable().columns.adjust();
		  },100);
        },
        consolidate(table, name) {
            var self = this;
            var lists = [];
            var dataTable = $(table).DataTable();
            var rows_selected = dataTable.column(0).checkboxes.selected();

            if (rows_selected.length <= 1) {
                EventBus.$emit("snackBar", {
                    text: "Please pick more than one rows to consolidate!",
                    snackbarColor: "amber darken-2"
                });
            }
            else {
                $.each(rows_selected, function(index, id) {
                    var item = {};
                    item.index = index;
                    item.id = id;
                    item.name = "";
                    lists.push(item);
                });

                EventBus.$emit("consolidateDialog", {
                    isConsolidationPopup: true,
                    ids: lists,
                    getDropdownAPIName: name + "/GetAllForDropdown",
                    consolidateAPIName: name + "/Consolidate",
                    tableName: table
                });
            }
        },
        getGlossaryDescription(queryName) {
            return store.state.db.transaction("GlossaryLibrary", "readwrite")
                .objectStore("GlossaryLibrary")
                .index("name")
                .get(queryName);
        },
        // Looping Form
        getTodayDate() {
            return new Date().toISOString().substr(0, 10);
        },
        getOptions() {
            this.formDetails.formInfo.forEach(function(element) {
                if (element.type == "select") {
                    axios({
                        method: "GET",
                        url: element.optionsAPI,
                        cache: {
                            ignoreCache: true,
                        },
                    }).then(function (response) {
                        element.options = response.data.result;
                    });
                }

                if (element.groupName) {
                    var group = element.groupName;
                    element[group].forEach(function(groupElement) {
                        if (groupElement.type == "combobox" && groupElement.optionsAPI) {
                            axios({
                                method: "GET",
                                url: groupElement.optionsAPI,
                            }).then(function (response) {
                                groupElement.options = response.data.result;
                            });
                        }
                    });
                }
            });
        },
        arrangePassportFormat(trial, palmNumber, progeny) {
            var trialNumber = trial ? trial.trialNumber : "-"; 
            var palmNo = palmNumber ? palmNumber : "-"; 
            var progenyCode = progeny ? progeny.code : "-"; 

            return trialNumber + "/" + palmNo + "(" + progenyCode + ")";
        },
        $_editRawData(FieldDataTableCode) {
            var self = this;
            axios({
                method: "GET",
                url: "FieldDataParameter/GetAll",
                params: {
                    FieldDataTableCode: FieldDataTableCode
                }
            })
                .then(function (response) {
                    var myResponse = response.data.result.items;

                    self.dynamicForm = myResponse.map(res => {
                        Object.keys(self.rawData).forEach(key => {
                            if (key == res.lowercaseName) {
                                res.defaultValue = self.rawData[key];
                            }
                        });
                        res.childrenCustomFields = [];
                        res.isRequired           = null;
                        res.minLength            = null;
                        res.maxLength            = null;
                        res.minValue             = null;
                        res.maxValue             = null;
                        return res;
                    });

                    self.dynamicForm.push({
                        name: "Reason", 
                        inputType: {
                            code: "TEXTAREA"
                        },
                        childrenCustomFields: [],
                        isRequired: null,
                        minLength: null,
                        maxLength: null,
                        minValue: null,
                        maxValue: null
                    });
				
                    self.$nextTick(function() {
                        self.editDialog = true;
                    });
                });
        },
        async $_comfirmUpdateRawData(FieldDataCategory) {
            var _dynamicForm = JSON.parse(JSON.stringify(this.dynamicForm));
            var tempObj = {
                id: this.paramID,
                recordDate: this.dateTimeValue
            };
            await _dynamicForm.forEach(item => {
			    tempObj[item.name] = item.value;
            });

            var self = this;
            axios({
			    method: "PUT",
			    url: this.FieldDataCategory + "/Update",
			    data: tempObj
            })
                .then(function (response) {
			    EventBus.$emit("snackBar", {
			        text: "Data Editted",
			        snackbarColor: "green"
			    });
			    self.isConfirmDialog = false;
			    self.getRawData();
			    self.getHistoryData();
                });
        },
        $_getFlagTooltip(data, flagLength, flagVariable) {
            var isFlag = "tableFlag";
            var flaggedTooltip = "";

            if ( flagLength > 0 ) {
                isFlag = "tableFlag flagged";
                flaggedTooltip = this.$_checkRecordFlag(data[flagVariable]);
            }

            var returnItem = `<i class="fas fa-flag ${isFlag}" data-toggle="tooltip" data-placement="top" title="${flaggedTooltip}"></i>`;
            returnItem = flagLength ? returnItem + " x " + flagLength : returnItem;

            return returnItem;
        },
        $_getStatusBtn(id, value) {
            return "<button type=\"button\" class=\"btn btn-secondary btn-sm dropdown-toggle tableStatus\" data-passingID=\"" + id + "\">" + value + "</button>";
        },
        $_tableStatus(name) {
            var self = this;
            $(name + " tbody").on( "click", ".tableStatus", function() {
                var id = $(this).data().passingid;
                var value =  $(this).text();
                if ($(this).text() == "  -  ") {
                    var value =  "-";
                }

                self.StatusInfo = {};
                self.StatusInfo.SelectedStatus = value;
                self.StatusInfo.StatusId = id;
                self.StatusInfo.UpdateMultiple = false;
                self.StatusInfo.Dialog = true;
            });
        },
        $_tabClick(lazyLoadTab) {
            this.lazyLoad[lazyLoadTab] = true;
            this.realignTable();
        },
        $_checkIsHigher(value, stdValue, key) {
            if (isArray(stdValue)) {
                var colValue = stdValue.map(e => e[key.title]);                
                return colValue.every(el => value > el);
            } else {
                return (value > stdValue);
            }
        },
        $_getSamplingsFlaggedCallBack(flagVar) {
            var flagVariable = flagVar;
            var callbackFn = function callbackFn(row, col, cell, index) {
                var flagLength = _.get(row, flagVariable).length;
                
                var isFlag = "tableFlag";
                var flaggedTooltip = "";

                if ( flagLength > 0 ) {
                    isFlag = "tableFlag flagged";
					
                    var flaggedData = _.get(row, flagVariable);
                    flaggedData.forEach((data, index) => {
                        flaggedTooltip = flaggedTooltip + ">> " + data.betweenSamplingsFlag.name + " accepted range " + data.betweenSamplingsFlag.acceptedRange + "\n";
                    });
                }

                var returnItem = `<i class="fas fa-flag ${isFlag}" data-toggle="tooltip" data-placement="top" title="${flaggedTooltip}"></i>`;
                returnItem = flagLength ? returnItem + " x " + flagLength : returnItem;

                return returnItem;
            };
            return callbackFn;
        },
        $_getCallBack(flagVar) {
            var flagVariable = flagVar;
            var callbackFn = function callbackFn(row, col, cell, index) {
                var flagLength = row[flagVariable].length;
				
                var isFlag = "tableFlag";
                var flaggedTooltip = "";

                if ( flagLength > 0 ) {
                    isFlag = "tableFlag flagged";
					
                    var flaggedData = row[flagVariable];
                    flaggedData.forEach((data, index) => {
                        flaggedTooltip = flaggedTooltip + ">> " + data.fieldDataFlag.condition + "\n";
                    });
                }

                var returnItem = `<i class="fas fa-flag ${isFlag}" data-toggle="tooltip" data-placement="top" title="${flaggedTooltip}"></i>`;
                returnItem = flagLength ? returnItem + " x " + flagLength : returnItem;

                return returnItem;
            };
            return callbackFn;
        },
        $_updateTableParam(params) {
            // Cannot assign like this.appendParams.PalmId = params.PalmId. It is NOT reactive
            // Assign in this way. this.$set(object, propertyName, value). (REACTIVE)

            this.$set(this.appendParams, "PalmId", params.PalmId);
            this.$set(this.appendParams, "TrialId", params.TrialId);
            this.$set(this.appendParams, "ProgenyId", params.ProgenyId);
            this.$set(this.appendParams, "Year", params.Year);
            this.$set(this.appendParams, "HasFailChecking", params.SelectedFlagOpt);
            this.$set(this.appendParams, "Status", params.SelectedStatusOpt);
            this.$set(this.appendParams, "RecordDateFrom", params.StartDate);
            this.$set(this.appendParams, "RecordDateTo", params.EndDate);
            this.$set(this.appendParams, "TrialPalmNumber", params.PalmNumber);
            this.$set(this.appendParams, "CreationTimeFrom", params.CreationTimeFrom);
            this.$set(this.appendParams, "CreationTimeTo", params.CreationTimeTo);
            this.$set(this.appendParams, "CreatorUserId", params.CreatorUserId);
            this.$set(this.appendParams, "RecordYearFrom", params.RecordYearFrom);
            this.$set(this.appendParams, "RecordYearTo", params.RecordYearTo);
        },
        $_confirmTableEdit(index, row, apiCategory) {
            var self = this;
            axios({
                method: "PUT",
                url: apiCategory + "/Update",
                data: { ...row }
            }).then(function (response) {
                EventBus.$emit("snackBar", {
                    text: "Updated Succesfully",
                    snackbarColor: "green darken-2"
                });
                self.tableKey++;
            });
        },
        $_confirmTableDelete(index, row, apiCategory) {
            var self = this;
            axios({
                method: "DELETE",
                url: apiCategory + "/Delete",
                params: {
                    "Id": row.id,
                }
            }).then(function (response) {
                EventBus.$emit("snackBar", {
                    text: "Row Deleted Succesfully",
                    snackbarColor: "green darken-2"
                });
                self.tableKey++;
            });
        },
        $_updateTable(key) {
            var fn = function updateTableKey() {
                key++;
            };
            return fn;
        },
        $_getCreationTimeFormat() {
            var creationTimeFormat = function formatter (row, col, cell, index) {
                return moment(cell).local().format("lll");
            };
            return creationTimeFormat;
        },
        $_getFlaggedValue() {
            var flaggedValueFormat = function formatter (row, col, cell, index) {
                var data = JSON.parse(cell);
                return Object.entries(data[0]).map(x => x.join(" : ")).join(", ");
            };
            return flaggedValueFormat;
        },
        $_getYearFormat() {
            var yearFormat = function formatter (row, col, cell, index) {
                return moment(cell).local().format("YYYY");
            };
            return yearFormat;
        },
        $_getFixedDecimenPoint(number) {
            var toFixedDecimalFormat = function formatter (row, col, cell, index) {
                if (cell == "-" || cell == null) return "-";
                return parseFloat(Math.round(cell * 100) / 100).toFixed(number || 2);
            };
            return toFixedDecimalFormat;
        },
        $_reloadAgrinomeTable() {
            console.log(this.$refs["agrinome-table"]);
            this.$refs["agrinome-table"].getTableData();
        },
        $_getLast12Months() {
            var self = this;
            var date = new Date();
            date.setMonth(date.getMonth() - 1);

            var months = [];
            var year = ["Jan.", "Feb.", "Mar.", "Apr.", "May", "Jun.", "Jul.", "Aug.", "Sept.", "Oct.", "Nov.", "Dec."];
    
            date.setDate(1);
            for (let i = 0; i <= 11; i++) {
                months.push(year[date.getMonth()] + " " + date.getFullYear());
                date.setMonth(date.getMonth() - 1);
            }
            return months;
        },
        $_getLast30Days() {
            var today = new Date();
            var date = new Date(today);
            date.setDate(today.getDate() - 1);

            var days = [];
    
            for (let i = 0; i <= 30; i++) {
                var day = date.getDay();
                if (day >= 1 && day <= 5) {
                    days.push(moment(new Date(date)).local().format("D/M/YY"));
                }
                date.setDate(date.getDate() - 1);
            }
            return days;
        },
        $_getLast5Days() {
            var self = this;
            var today = new Date();
            var date = new Date(today);
            date.setDate(today.getDate() - 1);
            var days = [];
            var week = ["Sun", "Mon", "Tues", "Wed", "Thur", "Fri", "Sat"];
    
            for (let i = 0; i <= 6; i++) {
                var day = date.getDay();
                if (day >= 1 && day <= 5) {
                    days.push(week[day] + " (" + moment(date).local().format("D/M") + ")");
                }
                date.setDate(date.getDate() - 1);
            }
			
            return days;
        },
        $_randomNumber(min, max) {
            return Math.floor((Math.random() * (max - min)) + min);
        },
        $_addEscListener() {
            document.addEventListener("webkitfullscreenchange", this.exitHandler, false);
            document.addEventListener("mozfullscreenchange", this.exitHandler, false);
            document.addEventListener("fullscreenchange", this.exitHandler, false);
            document.addEventListener("MSFullscreenChange", this.exitHandler, false);
        },
        $_navigateTo(pageInfo) {
            this.$router.push(pageInfo);
        },
        $_navigateTo_NewPage(pageName) {
            let routeData = this.$router.resolve({ name: pageName });
            window.open(routeData.href, "_blank");
        },
        $_tableSearch(tableId) {
            var self = this;
            var searchValue = this.$store.state.searchQuery;
            if (searchValue) {
                var table = $("#" + tableId).DataTable();
                this.$nextTick(() => {
                    setTimeout(() => {
                        table.search( searchValue ).draw();
                        this.$store.commit("storeSearchQuery", "");
                    }, 500);
                });
            }
        },
        $_checkPermission(name) {
            return PermissionService.getPermissionDict(name);
        },
        $_numberFormatter(num, digits) {
            var si = [
                { value: 1, symbol: "" },
                { value: 1E3, symbol: "k" },
                { value: 1E6, symbol: "M" },
                { value: 1E9, symbol: "G" },
                { value: 1E12, symbol: "T" },
                { value: 1E15, symbol: "P" },
                { value: 1E18, symbol: "E" }
            ];

            var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
            var i;
            for (i = si.length - 1; i > 0; i--) {
                if (num >= si[i].value) {
                    break;
                }
            }

            return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
        },
        $_numberWithCommas(num) {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        $_isJsonString(str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        },
        $_triggerSuccessNotify(message) {
            EventBus.$emit("snackBar", {
                text: message,
                snackbarColor: "green darken-2"
            });
        },
        $_checkIsImageAvailable() {
            var isImageAvailable = function formatter (row, col, cell, index) {
                if (cell && cell.length > 0) {
                    return "Yes";
                }
                else return "No";
            };
            return isImageAvailable;
        }
    },
};


// WEBPACK FOOTER //
// ./src/mixin.js